
import { FdmPlugin, FdmBucketPlugin, FdmPluginInterface } from '../plugins';
import { BucketActionController } from './bucket-action-controller';

export class BucketHandler extends FdmBucketPlugin implements FdmPluginInterface {

    // required name identifier
    static meta = {
        name: 'bucket-handler',
        translator: 'PLUGINS.GUIDES_CONTROLLER',

        category: FdmPlugin.category.generic,
        cardinality: FdmPlugin.cardinality.one,
        types: [ FdmPlugin.types.bucketsController ]
    };

    // the bucket.component we're drawing to
    component:any = null;

    // the action controller that deals with data and interaction
    actionController:BucketActionController  = null;

    registerComponent ( c:any = null ) {
        if ( c ) {
            this.component = c;
        }
    }

    registerActionController ( c:any = null ) {
        if ( c ) {
            this.actionController = c;
        }
    }

    end() {
        if ( this.actionController ) {
            this.actionController.destroy();
        }
    }

    emptyController() {
        if ( this.actionController ) {
            this.actionController.unloadAllItems();
        }
    }

    tell ( action:string = 'update', data:any = null ) {
        // console.log ( 'BUCKET_HANDLER tell()', this, data );
            
        if ( this.actionController ) {

            this.actionController.unloadAllItems();
            
            // console.log ( 'BUCKET_HANDLER TOLD!!', this.actionController );
            this.actionController.config({ object: data });
        }

    }

    
}


